import { task, collated } from './helpers';
import ItemsAPI from 'api/items';

export class Items {
	@task
	@collated
	fetchItemDetailsItem({ promotionId, categoryId, itemId, itemNumber }) {
		return ItemsAPI.fetchItemDetailsItem(
			promotionId,
			categoryId,
			itemId,
			itemNumber
		);
	}

	@task
	@collated
	fetchItemDetailsPack({ promotionId, packId, categoryId }) {
		return ItemsAPI.fetchItemDetailsPack(promotionId, packId, categoryId);
	}

	@task
	fetchChooseColors(categoryId, itemId, packId, isPack) {
		return ItemsAPI.fetchChooseColors(categoryId, itemId, packId, isPack);
	}
}

export default new Items();



// WEBPACK FOOTER //
// ./src/state/Items.js